var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cpSettingsPageRef",staticStyle:{"height":"100vh","width":"100%","border":"none"},attrs:{"id":"cpSettingsPage"}},[_vm._v(" Loading... ")])}
var staticRenderFns = []

export { render, staticRenderFns }